var exports = {
  "x6": "xa15a2ab7--098056--button",
  "Vi": "xa15a2ab7--098056--button--active",
  "Kk": "xa15a2ab7--098056--icon",
};

module.exports = exports;
